import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import { hideScrollY } from 'src/theme/styles';

import { Logo } from 'src/components/logo';
import { Scrollbar } from 'src/components/scrollbar';
import { NavSectionMini, NavSectionVertical } from 'src/components/nav-section';

import { NavToggleButton } from '../components/nav-toggle-button';

// ----------------------------------------------------------------------

export function NavVertical({ sx, data, slots, isNavMini, layoutQuery, onToggleNav, ...other }) {
  const theme = useTheme();

  // The template gives the drawer its own toolbar row — same height as the app bar beside it,
  // brand on the left, collapse chevron on the right, divider underneath. That replaces the
  // button that used to float on the drawer's outer edge.
  const renderTopArea = (
    <Box
      sx={{
        gap: 1,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        height: 'var(--layout-header-desktop-height)',
        justifyContent: isNavMini ? 'center' : 'flex-start',
        borderBottom: `1px solid var(--layout-nav-border-color)`,
        ...(!isNavMini && { pl: 2, pr: 1 }),
      }}
    >
      {!isNavMini && (
        <>
          <Logo width={112} height={32} />
          <Box sx={{ flexGrow: 1 }} />
        </>
      )}

      <NavToggleButton
        isNavMini={isNavMini}
        onClick={onToggleNav}
        sx={{
          top: 'auto',
          left: 'auto',
          border: 'none',
          display: 'none',
          position: 'static',
          transform: 'none',
          bgcolor: 'transparent',
          [theme.breakpoints.up(layoutQuery)]: {
            display: 'inline-flex',
          },
        }}
      />
    </Box>
  );

  const renderNavVertical = (
    <Scrollbar fillContent>
      {/* Items are inset by 8px so the selected pill floats inside the drawer rather than
          running into its edges — the full-bleed treatment only works with square corners. */}
      <NavSectionVertical
        data={data}
        sx={{ px: 1, flex: '1 1 auto' }}
        slotProps={{ subheader: { pl: 1.5, pr: 1.5 } }}
        {...other}
      />

      {/* {slots?.bottomArea ?? <NavUpgrade />} */}
    </Scrollbar>
  );

  const renderNavMini = (
    <>
      <NavSectionMini
        data={data}
        sx={{ pb: 2, px: 0.5, ...hideScrollY, flex: '1 1 auto', overflowY: 'auto' }}
        {...other}
      />

      {slots?.bottomArea}
    </>
  );

  return (
    <Box
      sx={{
        top: 0,
        left: 0,
        height: 1,
        display: 'none',
        position: 'fixed',
        flexDirection: 'column',
        bgcolor: 'var(--layout-nav-bg)',
        zIndex: 'var(--layout-nav-zIndex)',
        borderRight: `1px solid var(--layout-nav-border-color)`,
        width: isNavMini ? 'var(--layout-nav-mini-width)' : 'var(--layout-nav-vertical-width)',
        transition: theme.transitions.create(['width'], {
          easing: 'var(--layout-transition-easing)',
          duration: 'var(--layout-transition-duration)',
        }),
        [theme.breakpoints.up(layoutQuery)]: {
          display: 'flex',
        },
        ...sx,
      }}
    >
      {slots?.topArea ?? renderTopArea}

      {isNavMini ? renderNavMini : renderNavVertical}
    </Box>
  );
}
